"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Header", {
  enumerable: true,
  get: function get() {
    return _Header["default"];
  }
});
Object.defineProperty(exports, "DateFormatter", {
  enumerable: true,
  get: function get() {
    return _DateFormatter["default"];
  }
});
Object.defineProperty(exports, "ExpandButton", {
  enumerable: true,
  get: function get() {
    return _ExpandButton["default"];
  }
});
Object.defineProperty(exports, "DateTimeFormatter", {
  enumerable: true,
  get: function get() {
    return _DateTimeFormatter["default"];
  }
});
Object.defineProperty(exports, "ASC", {
  enumerable: true,
  get: function get() {
    return _SortIcon.ASC;
  }
});
Object.defineProperty(exports, "DESC", {
  enumerable: true,
  get: function get() {
    return _SortIcon.DESC;
  }
});
Object.defineProperty(exports, "NO_DIRECTION", {
  enumerable: true,
  get: function get() {
    return _SortIcon.NO_DIRECTION;
  }
});
Object.defineProperty(exports, "Row", {
  enumerable: true,
  get: function get() {
    return _Row["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactVirtualized = require("react-virtualized");
var _Header = _interopRequireDefault(require("./Header"));
var _DateFormatter = _interopRequireDefault(require("./formatters/DateFormatter"));
var _ExpandButton = _interopRequireDefault(require("./ExpandButton"));
var _DateTimeFormatter = _interopRequireDefault(require("./formatters/DateTimeFormatter"));
var _SortIcon = require("./SortIcon");
var _useCellResize = require("./useCellResize");
var _StringUtils = require("../../utils/StringUtils");
var _Row = _interopRequireDefault(require("./Row"));
var _ColumnPropTypes = _interopRequireDefault(require("./ColumnPropTypes"));
var _DesktopTabletView = _interopRequireDefault(require("../../elements/view/DesktopTabletView"));
var _MobileView = _interopRequireDefault(require("../../elements/view/MobileView"));
var _MobileAccordions = _interopRequireDefault(require("../accordion/MobileAccordions"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();
  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };
  return cache;
}
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }
  var cache = _getRequireWildcardCache();
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;
  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var Table = _styledComponents["default"].div.attrs(function () {
  return {
    className: "bcr-table"
  };
}).withConfig({
  displayName: "BestTable__Table",
  componentId: "enftoz-0"
})(["*:focus{outline:none;}position:relative;border:1px solid ", ";overflow-x:scroll;width:100%;"], function (props) {
  return props.theme["grey"];
});
var Body = _styledComponents["default"].div.attrs(function () {
  return {
    className: "bcr-table-body"
  };
}).withConfig({
  displayName: "BestTable__Body",
  componentId: "enftoz-1"
})(["overflow:visible;height:", "px;"], function (props) {
  return props.height;
});
var sum = function sum(accumulator, currentValue) {
  return accumulator + currentValue;
};
var tableId = "bcr-table-".concat((0, _StringUtils.uniqueStr)());
var rowPrefix = "bcr-row-".concat((0, _StringUtils.uniqueStr)());
var BestTable = function BestTable(_ref) {
  var data = _ref.data,
    columns = _ref.columns,
    expansion = _ref.expansion,
    headerHeight = _ref.headerHeight,
    maxTableHeight = _ref.maxTableHeight,
    rowHeight = _ref.rowHeight,
    sortColumn = _ref.sortColumn,
    sortDirection = _ref.sortDirection,
    sortFunction = _ref.sortFunction,
    selection = _ref.selection,
    rowStylesGetter = _ref.rowStylesGetter,
    minColumnWidth = _ref.minColumnWidth,
    autogrow = _ref.autogrow,
    accordion = _ref.accordion,
    displayExpansionButton = _ref.displayExpansionButton;
  var _useState = (0, _react.useState)(),
    _useState2 = _slicedToArray(_useState, 2),
    lastIndex = _useState2[0],
    setLastIndex = _useState2[1];
  var _useState3 = (0, _react.useState)(0),
    _useState4 = _slicedToArray(_useState3, 2),
    BodyHeight = _useState4[0],
    setBodyHeight = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    expandedRows = _useState6[0],
    setExpandedRows = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    tableSubRows = _useState8[0],
    setTableSubRows = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = _slicedToArray(_useState9, 2),
    anyAreExpanded = _useState10[0],
    setAnyAreExpanded = _useState10[1];
  var list = (0, _react.useRef)();
  var TableWidth = columns.map(function (c) {
    return c.width || c.minWidth ? c.width || c.minWidth : minColumnWidth;
  }).reduce(function (a, b) {
    return a + b;
  });
  var cellMeasurerCache = new _reactVirtualized.CellMeasurerCache({
    fixedWidth: true,
    defaultHeight: rowHeight
  });
  var columnSizes = [];
  var tableHasSubRows = !!data.filter(function (d) {
    return !!d.subRows;
  }).length;
  var expandSpace = !!expansion || !!tableHasSubRows ? 50 : 0;
  var fixedColumns = columns.filter(function (c) {
    return c.width;
  });
  var fixedWidths = fixedColumns.map(function (c) {
    return c.width || 0;
  }).reduce(sum) + expandSpace;
  columns.forEach(function (col, index) {
    columnSizes[index] = col.width || (0, _useCellResize.useCellResize)(tableId, columns.length - fixedColumns.length, fixedWidths, col.minWidth);
  });
  var recompute = function recompute(index) {
    var interval = setInterval(function () {
      cellMeasurerCache.clear(index, 0);
      if (list && list.recomputeRowHeights) {
        list.recomputeRowHeights(index);
      }
    }, 10);
    setTimeout(function () {
      clearInterval(interval);
    }, 1500);
  };
  var tableExpanded = function tableExpanded(index, newState) {
    var value = _objectSpread({}, expandedRows);
    value[index] = newState;
    setExpandedRows(value);
    setLastIndex(index);
  };
  var calculateBodyHeight = (0, _react.useCallback)(function () {
    if (autogrow) {
      var shouldAutoGrow = data.length <= 6;
      var tableHeight = data.length * rowHeight + headerHeight;
      setTimeout(function () {
        var growth = 0;
        if (shouldAutoGrow) {
          var expandedValues = Object.values(expandedRows).filter(function (v) {
            return !!v;
          });
          if (expandedValues.length > 0) {
            for (var _i2 = 0, _Object$entries = Object.entries(expandedRows); _i2 < _Object$entries.length; _i2++) {
              var _Object$entries$_i = _slicedToArray(_Object$entries[_i2], 2),
                key = _Object$entries$_i[0],
                value = _Object$entries$_i[1];
              if (!!value) {
                var selector = "".concat(rowPrefix, "-").concat(key);
                var el = document.getElementById(selector) || document.querySelector(selector);
                growth += el.scrollHeight;
              }
            }
          }
        }
        var calculated = tableHeight - headerHeight + growth;
        setBodyHeight(Math.min(calculated, maxTableHeight));
      }, 0);
    } else {
      setBodyHeight(maxTableHeight);
    }
  }, [expandedRows]);
  var expandAll = function expandAll() {
    var newExpanded = {};
    for (var i = 0; i < data.length; i++) {
      newExpanded[i] = !anyAreExpanded;
    }
    setExpandedRows(newExpanded);
  };
  (0, _react.useEffect)(function () {
    recompute();
    calculateBodyHeight();
    var containsSubRows = false;
    data.forEach(function (d) {
      if (!!d.subRows) {
        containsSubRows = true;
      }
    });
    if (containsSubRows !== tableSubRows) {
      setTableSubRows(containsSubRows);
    }
  }, [data]);
  (0, _react.useEffect)(function () {
    calculateBodyHeight();
  }, [expandedRows, lastIndex, rowHeight, headerHeight]);
  (0, _react.useEffect)(function () {
    var values = Object.values(expandedRows);
    setAnyAreExpanded(values.includes(true));
  }, [expandedRows]);
  var RowRenderer = function RowRenderer(_ref2) {
    var index = _ref2.index,
      key = _ref2.key,
      style = _ref2.style,
      parent = _ref2.parent;
    var value = data[index];
    var expanded = !!expandedRows[index];
    var hasSubRows = !!value.subRows;
    var rowStyle = rowStylesGetter(index, value);
    return _react["default"].createElement(_reactVirtualized.CellMeasurer, {
      key: rowPrefix + index + key,
      cache: cellMeasurerCache,
      parent: parent,
      columnIndex: 0,
      rowIndex: index
    }, _react["default"].createElement(_Row["default"], {
      index: index,
      rowPrefix: rowPrefix,
      style: style,
      rowStyle: rowStyle,
      rowHeight: rowHeight,
      expanded: expanded,
      columns: columns,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      value: value,
      hasSubRows: hasSubRows,
      columnSizes: columnSizes,
      expansion: expansion,
      displayExpansionButton: displayExpansionButton,
      recompute: recompute,
      tableExpanded: tableExpanded
    }));
  };
  RowRenderer.propTypes = {
    index: _propTypes["default"].number.isRequired,
    key: _propTypes["default"].string.isRequired,
    style: _propTypes["default"].object.isRequired,
    parent: _propTypes["default"].any.isRequired
  };
  var BCRTable = _react["default"].createElement(Table, {
    id: tableId
  }, _react["default"].createElement(_Header["default"], {
    headerHeight: headerHeight,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    sortFunction: sortFunction,
    columns: columns,
    expansion: !!expansion,
    subrows: !!tableSubRows,
    expandAll: expandAll,
    anyAreExpanded: anyAreExpanded,
    columnSizes: columnSizes,
    minWidth: TableWidth,
    displayExpansionButton: displayExpansionButton
  }), _react["default"].createElement(Body, {
    height: BodyHeight,
    className: "bcr-table-body"
  }, data && data.length && _react["default"].createElement(_reactVirtualized.AutoSizer, null, function (_ref3) {
    var height = _ref3.height,
      width = _ref3.width;
    var tableWidth = Math.max(width, TableWidth);
    return _react["default"].createElement(_reactVirtualized.List, {
      ref: function ref(_ref4) {
        list = _ref4;
      },
      width: tableWidth,
      scrollToIndex: lastIndex,
      height: height,
      rowCount: data.length,
      rowHeight: cellMeasurerCache.rowHeight,
      rowRenderer: RowRenderer
    });
  })));
  if (accordion) {
    return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(_MobileView["default"], null, _react["default"].createElement(_MobileAccordions["default"], {
      data: data,
      holderHeight: maxTableHeight + 300,
      accordion: accordion
    })), _react["default"].createElement(_DesktopTabletView["default"], null, BCRTable));
  } else {
    return BCRTable;
  }
};
BestTable.propTypes = {
  data: _propTypes["default"].array.isRequired,
  columns: _ColumnPropTypes["default"].isRequired,
  expansion: _propTypes["default"].any,
  headerHeight: _propTypes["default"].number,
  autogrow: _propTypes["default"].bool,
  maxTableHeight: _propTypes["default"].number,
  rowHeight: _propTypes["default"].number,
  sortColumn: _propTypes["default"].string,
  sortDirection: _propTypes["default"].oneOf([_SortIcon.ASC, _SortIcon.DESC, _SortIcon.NO_DIRECTION]),
  sortFunction: _propTypes["default"].func,
  selection: _propTypes["default"].shape({
    values: _propTypes["default"].array,
    onChange: _propTypes["default"].func,
    selectAll: _propTypes["default"].bool
  }),
  rowStylesGetter: _propTypes["default"].func,
  minColumnWidth: _propTypes["default"].number,
  accordion: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].element, _propTypes["default"].node, _propTypes["default"].object]),
  displayExpansionButton: _propTypes["default"].bool
};
BestTable.defaultProps = {
  headerHeight: 35,
  rowHeight: 35,
  maxTableHeight: 400,
  autogrow: false,
  sortColumn: null,
  sortDirection: null,
  sortFunction: function sortFunction() {},
  expansion: null,
  rowStylesGetter: function rowStylesGetter() {},
  minColumnWidth: 100,
  selection: null,
  accordion: null,
  displayExpansionButton: true
};
BestTable.ASC = _SortIcon.ASC;
BestTable.DESC = _SortIcon.DESC;
BestTable.NO_DIRECTION = _SortIcon.NO_DIRECTION;
BestTable.DateFormatter = _DateFormatter["default"];
BestTable.DateTimeFormatter = _DateTimeFormatter["default"];
BestTable.Header = _Header["default"];
BestTable.Row = _Row["default"];
BestTable.ExpandButton = _ExpandButton["default"];
var _default = BestTable;
exports["default"] = _default;